import DashboardReportBarChart from './DashboardReportBarChartContainer';

export default DashboardReportBarChart;
